import { MeetingViewMeetingNodeNewPageFragmentFragment } from "types/graphql-schema";

import { classNames } from "@helpers/css";

import MeetingSidebarAIContainer from "../meeting-sidebar/ai-container";
import MeetingSummaryGroupTranscription from "./summary-group-transcription";

const MeetingSummary = ({
  meeting,
  meetingGroupId,
  isCurrentMeeting = false,
}: {
  meeting: MeetingViewMeetingNodeNewPageFragmentFragment;
  meetingGroupId: number;
  isCurrentMeeting?: boolean;
}) => {
  return (
    <div>
      <MeetingSidebarAIContainer meeting={meeting}>
        {({ meeting: transcriptMeeting, refetch, loading }) => (
          <div className={classNames("text-sm flex flex-col gap-6")}>
            <MeetingSummaryGroupTranscription
              isCurrentMeeting={isCurrentMeeting}
              meeting={transcriptMeeting}
              meetingGroupId={meetingGroupId}
              refetch={refetch}
              loading={loading}
            />
          </div>
        )}
      </MeetingSidebarAIContainer>
    </div>
  );
};

export default MeetingSummary;
